import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import Wrapper from './Wrapper.js';
import FeedbackForm from './FeedbackForm/index.js';
import ThankyouView from './ThankyouView.js';

var BetaNpsForm = /*#__PURE__*/function (_React$Component) {
  function BetaNpsForm(props) {
    var _this;
    _classCallCheck(this, BetaNpsForm);
    _this = _callSuper(this, BetaNpsForm, [props]);
    _this.state = {
      isSubmitted: false,
      comment: ""
    };
    _this.onScoreSelect = _this.onScoreSelect.bind(_this);
    _this.onFeedbackSubmit = _this.onFeedbackSubmit.bind(_this);
    _this.onCommentChange = _this.onCommentChange.bind(_this);
    return _this;
  }
  _inherits(BetaNpsForm, _React$Component);
  return _createClass(BetaNpsForm, [{
    key: "onScoreSelect",
    value: function onScoreSelect(score) {
      this.setState({
        score: score
      });
    }
  }, {
    key: "onFeedbackSubmit",
    value: function onFeedbackSubmit(e) {
      var _this2 = this;
      e.preventDefault();
      var me = this.props.me;
      var _this$state = this.state,
        score = _this$state.score,
        comment = _this$state.comment;
      var payload = {
        date: new Date().toISOString(),
        full_name: "".concat(me.firstName, " ").concat(me.lastName),
        email: me.primaryEmail,
        member_id: me.id,
        account_type: me.type,
        nps_score: score,
        nps_comment: comment,
        url: window.location.href
      };
      var options = {
        body: JSON.stringify(payload),
        method: "POST"
      };
      var url = "https://hooks.zapier.com/hooks/catch/4140728/cs3ext/";
      window.fetch(url, options).then(function () {
        return _this2.setState({
          isSubmitted: true,
          comment: "",
          score: null
        });
      })["catch"](function () {
        return _this2.setState({
          isSubmitted: true,
          comment: "",
          score: null
        });
      });
    }
  }, {
    key: "onCommentChange",
    value: function onCommentChange(event) {
      this.setState({
        comment: event.target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        score = _this$state2.score,
        comment = _this$state2.comment,
        isSubmitted = _this$state2.isSubmitted;
      var intercom = this.props.intercom;
      return intercom ? /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(FeedbackForm, {
        hide: isSubmitted,
        onFormSubmit: this.onFeedbackSubmit,
        onScoreSelect: this.onScoreSelect,
        onCommentChange: this.onCommentChange,
        comment: comment,
        score: score
      }), /*#__PURE__*/React__default.createElement(ThankyouView, {
        open: isSubmitted
      })) : null;
    }
  }]);
}(React__default.Component);
BetaNpsForm.propTypes = {
  intercom: PropTypes.func.isRequired,
  me: PropTypes.object.isRequired
};

export { BetaNpsForm as default };
